module.exports = __webpack_public_path__ + "img/5.69ee5ab8.png";